import React from 'react';
import useGameFrame from '../account/useGameFrame';

// A game <iframe> that takes part in progress sync (see useGameFrame.js).
// `src` is a game build path such as "/sudoku/index.html"; its first path
// segment is the game's id, the same id /play/<id> uses.
function SyncedGameFrame({ src, title, gameName, ...rest }) {
  const gameId = src.split('/').filter(Boolean)[0];
  const frame = useGameFrame(src, gameId, gameName || title);
  return <iframe ref={frame.ref} src={src} title={title} onLoad={frame.onLoad()} {...rest} />;
}

export default SyncedGameFrame;
